import { Styles } from 'react-modal'
import theme from 'theme_'

import { StyledModalMobileContent, StyledModalMobileInner } from './styles'
import { ModalProps } from './types'

// Content styling in styles.ts; Overlay styling here
export const customModalStyles: Styles = {
  content: {
    padding: 0,
  },
  overlay: {
    zIndex: theme.zIndex.modal,
    background: theme.colors.grey,
  },
}

function BaseMobileModal(props: ModalProps) {
  return (
    <StyledModalMobileContent
      ariaHideApp={false}
      style={customModalStyles}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onAfterOpen={() => (document.body.style.overflow = 'hidden')}
      onAfterClose={() => (document.body.style.overflow = 'unset')}
      {...props}
    >
      <StyledModalMobileInner
        innerContainerStyle={{
          backgroundColor: props.backgroundColor || 'initial',
        }}
      >
        {props.children}
      </StyledModalMobileInner>
    </StyledModalMobileContent>
  )
}

export default BaseMobileModal
